import { Section } from 'src/app/components/Elements/Section';
import type { PharmacyReasonProps } from 'src/app/components/PageSections/WhyPeopleLoveCapsule';

import { FullServicePharmacy } from '../styles';

interface CapsulePharmacyProps extends PharmacyReasonProps {
  color?: string;
}

export const CapsulePharmacySection = (content: CapsulePharmacyProps) => {
  const { color, title, subtitle, sections } = content;
  return (
    <Section color={color ? color : 'capsuleGreen00'}>
      <FullServicePharmacy content={{ title, subtitle, sections }} />
    </Section>
  );
};
